import { NavItem, Select } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../../../../../hooks'
import { TaxationType } from '../../../../enums/taxationType'
import { OrganizationAccountingFormSchema } from '../../../../utils/organizationAccountingSettingsFormData'

export const TaxationTypeFormItem = (): ReactElement => {
  const { FormItem } = useFormContext<OrganizationAccountingFormSchema>()
  const { t } = useTranslation()

  const items: NavItem<TaxationType>[] = useMemo(
    () => [
      {
        id: TaxationType.OnPayment,
        value: TaxationType.OnPayment,
        children: t('settings.organization.accounting.taxation_type.on_payment'),
      },
      {
        id: TaxationType.OnCreation,
        value: TaxationType.OnCreation,
        children: t('settings.organization.accounting.taxation_type.on_creation'),
      },
    ],
    [t],
  )

  return (
    <FormItem
      name="taxationType"
      label={t('settings.organization.accounting.taxation_type')}
      render={({ field: { onChange, value, ...rest } }) => (
        <Select<TaxationType>
          dropdownSize="fitTrigger"
          items={items}
          onSelect={onChange}
          selectedId={value ?? undefined}
          {...rest}
        />
      )}
    />
  )
}
